var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcDelete = function SvgIcDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_delete",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_player_minimalize"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8452314,7 C20.3975161,7 20.8452314,7.44771525 20.8452314,8 C20.8452314,8.04782247 20.8418009,8.09558334 20.8349663,8.14291492 L18.5246118,24.1429149 C18.453572,24.6348898 18.0319543,25 17.5348768,25 L7.46512316,25 C6.96804573,25 6.54642796,24.6348898 6.47538818,24.1429149 L4.16503367,8.14291492 C4.08610394,7.59629938 4.46523819,7.08919475 5.01185373,7.01026502 C5.0591853,7.00343048 5.10694617,7 5.15476864,7 L19.8452314,7 Z M17.824,9.75 L7.175,9.75 L8.98,22.25 L16.019,22.25 L17.824,9.75 Z M14,0 C15.1045695,-2.02906125e-16 16,0.8954305 16,2 L15.995,2.125 L19.5,2.125 C20.2593915,2.125 20.875,2.74060847 20.875,3.5 C20.875,4.21472144 20.3296859,4.80207795 19.6324217,4.86870564 L19.5,4.875 L5.5,4.875 C4.74060847,4.875 4.125,4.25939153 4.125,3.5 C4.125,2.78527856 4.67031408,2.19792205 5.36757832,2.13129436 L5.5,2.125 L9.00386815,2.12541127 C9.00130207,2.083937 9,2.04212056 9,2 C9,0.8954305 9.8954305,2.02906125e-16 11,0 L14,0 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_delete.7f0b79be.svg";
export { ForwardRef as ReactComponent };